import { render, staticRenderFns } from "./ReviewsNew.vue?vue&type=template&id=121a4ea7&scoped=true"
import script from "./ReviewsNew.vue?vue&type=script&lang=ts"
export * from "./ReviewsNew.vue?vue&type=script&lang=ts"
import style0 from "./ReviewsNew.vue?vue&type=style&index=0&id=121a4ea7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a4ea7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('121a4ea7')) {
      api.createRecord('121a4ea7', component.options)
    } else {
      api.reload('121a4ea7', component.options)
    }
    module.hot.accept("./ReviewsNew.vue?vue&type=template&id=121a4ea7&scoped=true", function () {
      api.rerender('121a4ea7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/contractorDetails/ReviewsNew.vue"
export default component.exports